import { useCallback, useEffect, useState } from "react";
import { getDisponibilidad } from "../service/disponibilidadService";

export function useDisponibilidadSemana(desde, hasta) {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetchData = useCallback(async () => {
    if (!desde || !hasta) return;
    setLoading(true);
    setError(null);
    try {
      const res = await getDisponibilidad(desde, hasta);
      setData(res || []);
    } catch (err) {
      setError(err);
    } finally {
      setLoading(false);
    }
  }, [desde, hasta]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  return { data, loading, error, refresh: fetchData };
}
